document.addEventListener('DOMContentLoaded', () => {
    // Wait slightly to ensure Ghost has injected its script tag
    setTimeout(initSystemSearch, 500);
});

function initSystemSearch() {
    const searchBtns = document.querySelectorAll('[data-sys-search]');
    const modal = document.getElementById('sys-search-modal');
    if (!modal || searchBtns.length === 0) return;

    const closeBtn = modal.querySelector('.sys-search-close');
    const backdrop = modal.querySelector('.sys-search-backdrop');
    const input = document.getElementById('sys-search-input');
    const resultsContainer = document.getElementById('sys-search-results');
    const loader = modal.querySelector('.sys-search-loader');

    let allPosts = [];
    let isFetched = false;
    let isFetching = false;

    // Try to extract content API key from Ghost's native Sodo Search injection
    const sodoScript = document.querySelector('script[data-sodo-search]');
    let contentApiKey = '';
    let apiUrl = window.location.origin;

    if (sodoScript) {
        contentApiKey = sodoScript.dataset.key || '';
        if (sodoScript.dataset.sodoSearch) {
            apiUrl = sodoScript.dataset.sodoSearch;
        }
    }

    const initialStateHTML = `
        <div class="sys-initial-state">
            <svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="currentColor" stroke-width="1.5">
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
            <p>Start typing to search articles</p>
        </div>
    `;

    function openSearch(e) {
        if (e) e.preventDefault();

        modal.classList.add('is-active');
        document.body.style.overflow = 'hidden';

        // Timeout ensures the element is visible before focusing, fixing iOS bugs
        setTimeout(() => {
            input.focus();
        }, 100);

        if (!isFetched && !isFetching && contentApiKey) {
            isFetching = true;
            loader.style.display = 'block';

            // Format URL cleanly avoiding double slashes
            const cleanUrl = apiUrl.replace(/\/$/, "");

            // Check global member status injected from default.hbs and strip protected files if needed
            let filterQuery = '';
            if (typeof window.isGhostMember !== 'undefined' && !window.isGhostMember) {
                filterQuery = '&filter=tag:-[hash-dispatch,dispatch,hash-intel,intel]';
            }

            // Ghost 6 caps limit=all at 100, so walk every page of 100 until
            // meta.pagination.next runs out. (limit=all silently hid half the
            // archive from search before 2026-10-06.)
            const base = `${cleanUrl}/ghost/api/content/posts/?key=${contentApiKey}&limit=100${filterQuery}&fields=id,title,url,feature_image,published_at,excerpt`;
            const fetchAllPages = (page, acc) => fetch(`${base}&page=${page}`)
                .then(res => {
                    if (!res.ok) throw new Error('Search request failed: ' + res.status);
                    return res.json();
                })
                .then(data => {
                    const posts = acc.concat(data.posts || []);
                    const next = data.meta && data.meta.pagination && data.meta.pagination.next;
                    return (next && page < 50) ? fetchAllPages(next, posts) : { posts };
                });

            fetchAllPages(1, [])
                .then(data => {
                    allPosts = data.posts || [];
                    isFetched = true;
                    isFetching = false;
                    loader.style.display = 'none';

                    // If user already typed something while it was loading
                    if (input.value.trim().length >= 2) {
                        performSearch(input.value.trim());
                    } else {
                        resultsContainer.innerHTML = initialStateHTML;
                    }
                })
                .catch(err => {
                    isFetching = false;
                    console.error("Search error: ", err);
                    loader.style.display = 'none';
                    resultsContainer.innerHTML = '<p class="sys-error">Search is unavailable right now. Please try again.</p>';
                });
        } else if (isFetching) {
            // first load still in flight; results render when it lands
        } else if (!isFetched && !contentApiKey) {
            resultsContainer.innerHTML = '<p class="sys-error">Search is unavailable right now.</p>';
        } else if (input.value.trim().length < 2) {
            resultsContainer.innerHTML = initialStateHTML;
        }
    }

    function closeSearch() {
        modal.classList.remove('is-active');
        document.body.style.overflow = '';
        input.value = '';
        resultsContainer.innerHTML = '';
    }

    searchBtns.forEach(btn => {
        btn.addEventListener('click', openSearch);
    });

    closeBtn.addEventListener('click', closeSearch);
    backdrop.addEventListener('click', closeSearch);

    // Escape listener
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.classList.contains('is-active')) {
            closeSearch();
        }
    });

    function performSearch(query) {
        const lowerQuery = query.toLowerCase();
        resultsContainer.innerHTML = '';

        const matches = allPosts.filter(post =>
            (post.title && post.title.toLowerCase().includes(lowerQuery)) ||
            (post.excerpt && post.excerpt.toLowerCase().includes(lowerQuery))
        );

        if (matches.length === 0) {
            resultsContainer.innerHTML = '<p class="sys-no-results">No results found. Try another search.</p>';
            return;
        }

        matches.forEach(post => {
            const card = document.createElement('a');
            card.className = 'sys-search-card';
            card.href = post.url;

            const thumb = `
                <div class="sys-card-image" style="background-image: url('${post.feature_image || ''}'); ${post.feature_image ? '' : 'background: #222;'}"></div>
            `;

            // Excerpt formatting
            let excerptHtml = '';
            if (post.excerpt) {
                // Remove some potential HTML formatting if necessary, though excerpts usually are plain text
                excerptHtml = `<p class="sys-card-excerpt">${post.excerpt}</p>`;
            }

            // Date formatting
            let dateStr = '';
            if (post.published_at) {
                const d = new Date(post.published_at);
                dateStr = d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
            }

            card.innerHTML = `
                ${thumb}
                <div class="sys-card-content">
                    <h4>${post.title}</h4>
                    ${excerptHtml}
                    ${dateStr ? `<span class="sys-card-date">${dateStr}</span>` : ''}
                </div>
                <div class="sys-card-chevron">
                    <svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" stroke-width="2" fill="none"><polyline points="9 18 15 12 9 6"></polyline></svg>
                </div>
            `;
            resultsContainer.appendChild(card);
        });
    }

    let searchTimeout;
    input.addEventListener('input', (e) => {
        clearTimeout(searchTimeout);
        const query = e.target.value.trim();

        if (query.length < 2) {
            if (isFetched) {
                resultsContainer.innerHTML = initialStateHTML;
            }
            return;
        }

        searchTimeout = setTimeout(() => {
            if (isFetched) performSearch(query);
        }, 300);
    });
}
